<template>
    <div class="consent-wrapper TextUnderCkBox" data-testid="phx-covid-screening-consent">
        <div
            tabindex="0"
            aria-hidden="false"
            class="hint"
            v-text="$t('form.phxCovidScreeningConsentHint')"
        />
        <ol
            class="list-item"
            tabindex="0"
            aria-hidden="false">
            <li>
                <span
                    class="hint"
                    v-text="$t('form.phxCovidScreeningConsentPoint1')"
                />
            </li>
            <li>
                <span class="hint" v-html="phxCovidScreeningConsentPoint2" />
            </li>
            <li>
                <span
                    class="hint"
                    v-text="$t('form.phxCovidScreeningConsentPoint3')"
                />
            </li>
            <li>
                <span
                    class="hint"
                    v-text="$t('form.phxCovidScreeningConsentPoint4')"
                />
            </li>
            <li>
                <span class="hint" v-html="phxCovidScreeningConsentPoint5" />
            </li>
        </ol>

        <metadata-checkbox
            :metadata="getMetadata"
            :required="required"
            :value="value"
            @update:value="emitValue" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { replace } from 'lodash';
import MetadataCheckbox from '@/components/metadata/inputs/checkbox/MetadataCheckbox.vue';

export default {
    components: {
        MetadataCheckbox
    },
    props: {
        metadata: { type: Object, required: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: Boolean, required: true },
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
            getCurrentApplicationName: 'getCurrentApplicationName',
        }),
        getMetadata() {
            return {
                ...this.metadata,
                descriptionFr: this.$i18n.t('form.phxCovidScreeningConsentLabel'),
                descriptionEn: this.$i18n.t('form.phxCovidScreeningConsentLabel')
            };
        },
        phxCovidScreeningConsentPoint2() {
            return replace(this.$t('form.phxCovidScreeningConsentPoint2'),
                /%consentDomain%/g,
                this.consentLink1
            );
        },
        phxCovidScreeningConsentPoint5() {
            return replace(this.$t('form.phxCovidScreeningConsentPoint5'),
                /%consentDomain%/g,
                this.consentLink2
            );
        },
        consentLink1() {
            if (this.upperLocale === 'Fr') {
                return 'https://www.quebec.ca/sante/problemes-de-sante/a-z/coronavirus-2019/tests-de-depistage/faire-test-de-depistage';
            }
            return 'https://www.quebec.ca/en/health/health-issues/a-z/2019-coronavirus/testing-for-covid-19/get-covid-19-test';
        },
        consentLink2() {
            if (this.upperLocale === 'Fr') {
                return 'https://www.quebec.ca/sante/problemes-de-sante/a-z/coronavirus-2019/tests-de-depistage/utilisation-tests-rapides-maison#c127293';
            }
            return 'https://www.quebec.ca/en/health/health-issues/a-z/2019-coronavirus/testing-for-covid-19/rapid-home-testing#c127293';
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>

<style scoped lang="scss">
.TextUnderCkBox {
  border: 2px solid var(--v-border-metadata-color)!important;
  border-radius: 4px!important;
  padding: 1rem;
  background: rgba(255,255,255,1);
  color: rgba(0, 0, 0, 0.54);
  margin-top: 1rem;
  margin-bottom: 1rem;

    .list-items li {
      font-size: 14px;
      font-weight: 300;
      color: rgba(0, 0, 0, 0.84);
    }

    .list-items {
      margin-left: 30px;
      margin-top: 10px;
      list-style-type: disc;
      margin-bottom: 10px;
    }
}
</style>
